module.exports = {"components.notice.buttonLabel":"descartar"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es/components/Notice.json
// module id = 759
// module chunks = 0